// noinspection DuplicatedCode

import React, { useEffect, useState } from "react";

import { Colors } from "../../../assets/Colors";
import { fetchGet, fetchPost, fetchPostSilance } from "../../../fetchers";
import { useMutation } from "@tanstack/react-query";
import { DynamicTableSimple } from "../../../components/tablecard/DynamicTable";
import { Card } from "@material-tailwind/react";
import { isRequired, useForm } from "../../../components/isRequired";
import Modal from "@material-tailwind/react/Modal";
import ModalHeader from "@material-tailwind/react/ModalHeader";
import ModalBody from "@material-tailwind/react/ModalBody";
import { HrdInputGenerator } from "../../../components/form/HrdInputGenerator";
import ModalFooter from "@material-tailwind/react/ModalFooter";
import Button from "@material-tailwind/react/Button";
import "react-toastify/dist/ReactToastify.css";
import { BiArrowBack } from "react-icons/bi";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

const InsertAllocationPurchaseRequisitionPage = ({}) => {
  let initialState = {
    BisnisUnitID: "",
    DatePR: new Date(),
  };

  let initialStateModal = {
    SDTDate: new Date(),
  };
  const validations = [
    ({ UserPCName }) =>
      isRequired(UserPCName) || { UserPCName: "Nama UserPC wajib diisi" },
    ({ Status }) => isRequired(Status) || { Status: "Status wajib diisi" },
    ({ KelompokID }) =>
      isRequired(KelompokID) || { KelompokID: "Kelompok wajib diisi" },
    ({ Status }) => isRequired(Status) || { Status: "Kelompok wajib diisi" },
    ({ DetailAccountID }) =>
      isRequired(DetailAccountID) || {
        DetailAccountID: "Detail Account wajib diisi",
      },
    ({ Status }) =>
      isRequired(Status) || { Status: "Detail Account wajib diisi" },
  ];
  const allocation = useMutation((param) =>
    fetchPostSilance("Procurement/PurchaseRequisition/allocation", param)
  );

  const {
    changed,
    values,
    isValid,
    touched,
    submitHandler,
    customHandler,
    changeHandler,
    errors,
    blastChange,
  } = useForm(initialState, validations);
  const params = useParams();

  const barang = useMutation((formData) => fetchGet("Master/Barang/min"));
  const [buttonTouched, setButtonTouched] = useState(false);
  const [detail, setDetail] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showModalEdit, setShowModalEdit] = useState(false);
  const [modalDetail, setModalDetail] = useState(initialStateModal);
  const [priceComparison, setpriceComparison] = useState({});
  const [modalID, setModalID] = useState(0);
  const ModalOpener = (detail) => {
    setShowModal(true);
  };
  const param = useLocation();
  const priceComparisonData = useMutation((formData) =>
    fetchGet("Procurement/PriceComparisonFromPRID/" + formData)
  );
  const mutationGet = useMutation((formData) =>
    fetchGet("Procurement/PurchaseRequisition/" + formData)
  );
  const mutationAdd = useMutation((formData) =>
    fetchPost("Procurement/PurchaseRequisition", formData)
  );

  const ModalEdit = (detail, id) => {
    setModalID(id);
    setModalDetail(detail);
    setShowModal(true);
    setShowModalEdit(true);
  };

  const ModalDelete = (id) => {
    let newDetail = [...detail];
    newDetail.splice(id, 1);
    setDetail(newDetail);
  };

  const navigate = useNavigate();

  useEffect(() => {
    if (params.transid) {
      priceComparisonData.mutate(params.transid.replaceAll("-", "/"));
    }
  }, []);

  useEffect(() => {
    if (priceComparisonData.data) {
      setpriceComparison(priceComparisonData);
    }
    // priceComparison.mutate(params.transid.replaceAll("-", "/"));
  }, [priceComparisonData.status]);

  useEffect(() => {
    barang.mutate();
    if (params.transid) {
      mutationGet.mutate(params.transid.replaceAll("-", "/"));
      priceComparisonData.mutate(params.transid.replaceAll("-", "/"));
    }
    if (params.id) {
      customHandler(params.id, "BisnisUnitID");
    }
  }, []);

  useEffect(() => {
    if (mutationGet.data) {
      setDetail(mutationGet.data.data.PRList);
      blastChange(mutationGet.data.data);
    }
  }, [mutationGet.status]);

  useEffect(() => {
    if (mutationAdd) {
      if (mutationAdd.isSuccess) {
        navigate(
          "/procurment/transaction/Allocation/" + values["BisnisUnitID"]
        );
      }
    }
  }, [mutationAdd.status]);

  const header = [
    { name: "Barang", key: "BarangID", modifiers: "Barang" },
    { name: "Qty", key: "Qty", modifiers: "number" },
    { name: "SDTDate", key: "SDTDate", modifiers: "dateOnly" },
    { name: "Specification", key: "Specification", modifiers: "Text" },
  ];

  const Kirim = () => {
    setShowModal(!showModal);
  };

  return (
    <div className="md:ml-64">
      <div
        style={{ background: Colors.primary }}
        className="pt-14 pb-16 px-3 md:px-8 h-auto"
      >
        <div className="container mx-auto max-w-full">
          <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4"></div>
        </div>
      </div>
      <div className="px-3 md:px-8 h-auto -mt-32">
        <div className="container mx-auto max-w-full">
          <div className="grid grid-cols-1 px-4">
            <Card>
              <div className="flex flex-col  mt-5">
                <div className="flex w-full justify-end flex-col sm:flex-row ">
                  <button
                    onClick={() =>
                      navigate(
                        "/procurment/transaction/Allocation/" +
                          values["BisnisUnitID"]
                      )
                    }
                    className="flex flex-row items-center justify-center m-2 sm:my-0 bg-white hover:bg-main-100 hover:text-white text-gray-800 font-semibold py-2 px-4 border border-main-100 shadow rounded"
                  >
                    <BiArrowBack className="text-xl text-gray-800 pr-2" />
                    Kembali
                  </button>
                  <button
                    onClick={() => Kirim()}
                    className="flex flex-row items-center justify-center m-2 sm:my-0 bg-white hover:bg-main-100 hover:text-white text-gray-800 font-semibold py-2 px-4 border border-main-100 shadow rounded"
                  >
                    {mutationAdd.isLoading ? (
                      <>
                        <svg
                          aria-hidden="true"
                          role="status"
                          className="inline mr-3 w-4 h-4 text-white animate-spin"
                          viewBox="0 0 100 101"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                            fill="#E5E7EB"
                          />
                          <path
                            d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                            fill="current
                                       Color"
                          />
                        </svg>
                        Loading
                      </>
                    ) : (
                      "Buat Allocation"
                    )}
                  </button>
                </div>
                <div className="w-1/3">
                  <HrdInputGenerator
                    type={"BisnisUnit"}
                    value={values}
                    name={"BisnisUnitID"}
                    title={"Bisnis Unit"}
                    onChange={customHandler}
                    touched={touched}
                    buttonTouched={buttonTouched}
                    size={"full"}
                    required={true}
                    errors={errors}
                    disabled={true}
                  />
                </div>
                <div className="w-1/3">
                  <HrdInputGenerator
                    type={"dateOnly"}
                    value={values}
                    name={"DatePR"}
                    title={"Date PR"}
                    onChange={customHandler}
                    touched={touched}
                    buttonTouched={buttonTouched}
                    size={"full"}
                    required={true}
                    errors={errors}
                    disabled={true}
                  />
                </div>
                <div className="w-1/3">
                  <HrdInputGenerator
                    type={"TipePR"}
                    value={values}
                    name={"Tipe"}
                    title={"Tipe"}
                    onChange={customHandler}
                    touched={touched}
                    buttonTouched={buttonTouched}
                    size={"full"}
                    required={true}
                    errors={errors}
                    disabled={true}
                  />
                </div>
                {values.Tipe == "Jasa" && values.Termin1 > 0 ? (
                  <div className="w-1/3">
                    <HrdInputGenerator
                      type={"Termin"}
                      value={values}
                      name={"Termin1"}
                      title={"Termin 1 (%)"}
                      onChange={changeHandler}
                      touched={touched}
                      buttonTouched={buttonTouched}
                      size={"full"}
                      required={false}
                      errors={errors}
                      disabled={true}
                      priceComparison={priceComparison}
                      showNominal={true}
                      isApproval={false}
                    />
                  </div>
                ) : null}
                {values.Tipe == "Jasa" && values.Termin2 > 0 ? (
                  <div className="w-1/3">
                    <HrdInputGenerator
                      type={"Termin"}
                      value={values}
                      name={"Termin2"}
                      title={"Termin 2 (%)"}
                      onChange={changeHandler}
                      touched={touched}
                      buttonTouched={buttonTouched}
                      size={"full"}
                      required={false}
                      priceComparison={priceComparison}
                      showNominal={true}
                      errors={errors}
                      disabled={true}
                      isApproval={false}
                    />
                  </div>
                ) : null}
                {values.Tipe == "Jasa" && values.Termin3 > 0 ? (
                  <div className="w-1/3">
                    <HrdInputGenerator
                      type={"Termin"}
                      value={values}
                      name={"Termin3"}
                      title={"Termin 3 (%)"}
                      onChange={changeHandler}
                      touched={touched}
                      buttonTouched={buttonTouched}
                      priceComparison={priceComparison}
                      showNominal={true}
                      size={"full"}
                      required={false}
                      errors={errors}
                      disabled={true}
                      isApproval={false}
                    />
                  </div>
                ) : null}
                <div className="w-1/3">
                  <HrdInputGenerator
                    type={"text"}
                    value={values}
                    name={"Requester"}
                    title={"Requester"}
                    onChange={changeHandler}
                    touched={touched}
                    buttonTouched={buttonTouched}
                    size={"full"}
                    required={true}
                    errors={errors}
                    disabled={true}
                  />
                </div>
                <div className="w-1/2">
                  <HrdInputGenerator
                    type={"text"}
                    value={values}
                    name={"Remarks"}
                    title={"Remarks"}
                    onChange={changeHandler}
                    touched={touched}
                    buttonTouched={buttonTouched}
                    size={"full"}
                    required={true}
                    errors={errors}
                    disabled={true}
                  />
                </div>
                <hr />
                <DynamicTableSimple
                  data={detail}
                  header={header}
                  Master={false}
                  OnClick={ModalOpener}
                  name={"Purchase Requisition"}
                  barang={barang.data}
                  edit={ModalEdit}
                  delete={ModalDelete}
                />
              </div>
            </Card>
            <Modal
              size="lg"
              active={showModal}
              toggler={() => {
                setShowModal(true);
              }}
            >
              <ModalHeader
                className="mt-20"
                toggler={() => {
                  setShowModal(false);
                  setShowModalEdit(false);
                }}
              >
                Allocation
              </ModalHeader>
              <ModalBody>
                <form className="w-full">
                  <HrdInputGenerator
                    type={"text"}
                    value={values}
                    name={"PurchaseRequisitionID"}
                    title={"Purchase Requisition ID"}
                    touched={touched}
                    buttonTouched={buttonTouched}
                    size={"full"}
                    errors={errors}
                    disabled={true}
                  />
                  <HrdInputGenerator
                    type={"userPC"}
                    value={values}
                    name={"UserPCID"}
                    title={"UserPC"}
                    touched={touched}
                    onChange={customHandler}
                    buttonTouched={buttonTouched}
                    size={"full"}
                    errors={errors}
                  />
                </form>
              </ModalBody>
              <ModalFooter>
                <Button
                  color="red"
                  buttonType="link"
                  onClick={() => {
                    setShowModal(false);
                  }}
                  ripple="dark"
                >
                  Cancel
                </Button>

                <Button
                  className={"bg-green-700 disabled:bg-red-400"}
                  disabled={!values["UserPCID"]}
                  onClick={() => {
                    if (values["UserPCID"]) {
                      allocation.mutate(values, {
                        onSuccess: () => {
                          setShowModal(false);
                          setShowModalEdit(false);

                          toast.info("Loading table!", {
                            position: "top-center",
                            autoClose: 1000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: false,
                            draggable: true,
                            theme: "light",
                          });
                          setShowModal(false);
                          navigate(
                            "/procurment/transaction/Allocation/" +
                              values["BisnisUnitID"]
                          );
                        },
                      });
                    }
                  }}
                >
                  {allocation.isLoading ? (
                    <>
                      <svg
                        aria-hidden="true"
                        role="status"
                        className="inline mr-3 w-4 h-4 text-white animate-spin"
                        viewBox="0 0 100 101"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                          fill="#E5E7EB"
                        />
                        <path
                          d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                          fill="current
                                       Color"
                        />
                      </svg>
                      Loading
                    </>
                  ) : (
                    "Set Allocation dan Kirim"
                  )}
                </Button>
              </ModalFooter>
            </Modal>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InsertAllocationPurchaseRequisitionPage;
